'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  black: 'rgb(0, 0, 0)',
  grey: 'rgb(112, 112, 112)',
  lightGrey: 'rgb(186, 186, 186)',
  veryLightGrey: '#FAFAFA',
  white: 'rgb(255, 255, 255)',
  green: 'rgb(52, 199, 137)',
  lightGreen: 'rgb(176, 209, 195)',
  red: 'rgb(228, 53, 58)'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/themes/palette.js
// module id = 319
// module chunks = 0